import React, { useContext, useEffect, useState, useCallback } from "react";
import TadobaContext from "../Context/TadobaContext";
import LazyImage from "../LazyImage";
import Popup from "reactjs-popup";
import { makeRequest } from "../../api";
import { warningToaster } from "../../Data/Data";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";
import UnableToIdentifyModal from "./UnableToIdentifyModal";
import TigerCard from "./TigerCard";

const IdentifiedContainer = (props) => {
  const api = useContext(TadobaContext);
  const [uploadView, setUploadview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [identifiedTigers, setIdentifiedTigers] = useState([]);
  const [unIdentifiedTigers, setUnIdentifiedTigers] = useState([]);
  const [selectedTiger, setSelectedTiger] = useState("");
  const [clickedTiger, setClickedTiger] = useState("");
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedTigerIndex, setSelectedTigerIndex] = useState(0);
  const [tigerData, setTigerData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [unableToIdentifyTigers, setUnableToIdentifyTigers] = useState([]);
  const [activeButton, setActiveButton] = useState();
  const [activeTab, setActiveTab] = useState("identified");
  const [tigerslist, setTigersList] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedUnidIndex, setSelectedUnidIndex] = useState(null);

  const [unableToIdentifyTigerData, setUnableToIdentifyTigerData] = useState(
    []
  );
  const [unableToIdentifyModalOpen, setUnableToIdentifyModalOpen] =
    useState(false);
  const [tigerIds, setTigerIds] = useState(0);
  const [unIdTigerIds, setunIdTigerIds] = useState(0);

  const AllSpeciesSetup = (users) => {
    let result = [];
    users.map((value, key) => {
      const obj = {
        "Species name": value.name,
        "No. Of Images": value.no_of_images,
      };
      result.push(obj);
    });
    api.setSpecies(result);
  };

  useEffect(() => {
    const fetchSpecies = async () => {
      try {
        const result = await makeRequest("get", `api/v1/species/species/`);
        api.setAllSpecied(result.data.data);
        AllSpeciesSetup(result.data.data);
      } catch (error) {}
    };
    if (!localStorage.species) {
      fetchSpecies();
    } else {
      const storedData = JSON.parse(localStorage.species);
      api.setAllSpecied(storedData);
      AllSpeciesSetup(storedData);
    }
  }, []);

  let classified_items = [];
  for (const key in api.classification?.grouped_data) {
    classified_items.push(key);
  }

  useEffect(() => {
    if (!api.classification?.grouped_data?.Tiger || !api.identifiedTigers)
      return;
    const unidentifiedIds = [];

    const newClassification = api.classification?.grouped_data.Tiger.map(
      (item) => {
        const { id } = item;

        if (api.identifiedTigers?.unmatched?.includes(id)) {
          const unidentifiedTiger = {
            ...item,
            name: "Unidentified",
            checked: false,
          };
          api.setUnIdentifiedTigers((prev) => [...prev, unidentifiedTiger]);
          setUnIdentifiedTigers((prev) => [...prev, unidentifiedTiger]);

          unidentifiedIds.push(id);
          return unidentifiedTiger;
        } else if (api.identifiedTigers?.unidentified?.includes(id)) {
          const unidentifiedTiger = { ...item, name: "Unable to identify" };

          setUnableToIdentifyTigers((prev) => [...prev, unidentifiedTiger]);
          return unidentifiedTiger;
        } else {
          const identifiedName = api.identifiedTigers?.matched[id];
          const identifiedTiger = identifiedName
            ? { ...item, name: identifiedName }
            : null;
          return identifiedTiger;
        }
      }
    ).filter(Boolean);

    setunIdTigerIds(unidentifiedIds);
    setUploadview(true);
    const organisedData = organiseData(newClassification);
    api.setIdentifiedTigers(organisedData);

    let valuesArray = [];
    for (const key in organisedData) {
      if (organisedData.hasOwnProperty(key)) {
        valuesArray = valuesArray.concat(organisedData[key]);
      }
    }
    setIdentifiedTigers(valuesArray);
    const data = valuesArray.map((tiger) => tiger.id);
    setTigerIds(data);
  }, []);

  // get list of tigers for default selection
  useEffect(() => {
    const fetchTiger = async () => {
      setLoading(true);
      let token = "";
      try {
        if (localStorage.token) {
          token = localStorage.token;
        }

        const result = await makeRequest(
          "get",
          "api/v1/identification/species_tiger/"
        );
        const result_data = result.data.data;

        const names = result_data
          .map((tiger) => {
            if (tiger) {
              return {
                value: tiger.id,
                label: tiger.name,
              };
            }
            return null;
          })
          .filter(Boolean);
        localStorage.setItem("tigerList", JSON.stringify(names));
        setTigersList(names);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchTiger();
  }, []);

  const organiseData = (data) => {
    return data.reduce((acc, item) => {
      const { name, id, image_key, fileName } = item;
      if (name !== "Unidentified" && name !== "Unable to identify") {
        if (!acc[name]) {
          acc[name] = [];
        }

        acc[name].push({
          id: id,
          image_key: image_key,
          species_data_id: null,
          species_name: name,
          image: fileName,
          checked: false,
        });
      }

      return acc;
    }, {});
  };

  const identifyHandler = async (id, tigerId, type) => {
    let token = "";
    try {
      const data = new FormData();
      data.append("image_id", id);
      data.append("tiger_id", tigerId);
      data.append("origin", "upload");
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest(
        "post",
        `api/v1/identification/tiger_identify`,
        data
      );
      // setIsPopupOpen(false);
      identifyTiger(
        result.data.data,
        unIdentifiedTigers,
        unableToIdentifyTigers,
        identifiedTigers,
        type
      );
      if (type === "identified") {
        handleNext(selectedIndex, setSelectedIndex, tigerIds);
      } else if (type === "unidentified") {
        handleNext(selectedUnidIndex, setSelectedUnidIndex, unIdTigerIds);
      }
    } catch (error) {
      console.error(error);
    }
  };

  function identifyTiger(
    identifiedData,
    unIdentifiedTigers,
    unableToIdentifyTigers,
    identifiedTigers,
    type
  ) {
    const identifiedImageId = parseInt(identifiedData.data.image_id);
    const identifiedSpeciesName = identifiedData.data.name;

    if (type === "unidentified") {
      const index = unIdentifiedTigers.findIndex(
        (tiger) => tiger.id === identifiedImageId
      );
      if (index !== -1) {
        unIdentifiedTigers[index].species_name = identifiedSpeciesName;
        unIdentifiedTigers[index].checked = true;
      } else {
        const identifiedTiger = {
          id: identifiedData.data.image_id,
          species_name: identifiedSpeciesName,
          image: identifiedData.data.image,
          image_key: identifiedData.data.image_key,
          checked: true,
        };
        unIdentifiedTigers.push(identifiedTiger);
      }

      setUnIdentifiedTigers([...unIdentifiedTigers]);
    }
    if (type === "identified") {
      const index = identifiedTigers.findIndex(
        (tiger) => tiger.id === identifiedImageId
      );
      if (index !== -1) {
        identifiedTigers[index].species_name = identifiedSpeciesName;
        identifiedTigers[index].checked = true;
      } else {
        const identifiedTiger = {
          id: identifiedData.data.image_id,
          species_name: identifiedSpeciesName,
          image: identifiedData.data.image,
          image_key: identifiedData.data.image_key,
          checked: true,
        };
        identifiedTigers.push(identifiedTiger);
      }

      setIdentifiedTigers([...identifiedTigers]);
    }
    if (type === "unable") {
      const index = unableToIdentifyTigers.findIndex(
        (tiger) => tiger.id === identifiedImageId
      );
      if (index !== -1) {
        unableToIdentifyTigers[index].name = identifiedSpeciesName;
      } else {
        const unabletoIdentifiedTiger = {
          id: identifiedData.data.image_id,
          name: identifiedSpeciesName,
          fileName: identifiedData.data.image,
          image_key: identifiedData.data.image_key,
          checked: false,
        };
        unableToIdentifyTigers.push(unabletoIdentifiedTiger);
      }

      setUnableToIdentifyTigers([...unableToIdentifyTigers]);
    }
  }

  const fetchAdditionalImages = async (type, id) => {
    setPopupLoading(true);
    // setActiveButton(false);
    if (type === "identified") {
      setSelectedIndex(id);
    } else if (type === "unidentified") {
      setSelectedUnidIndex(id);
    }
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }

      const data = { id: id, origin: "upload" };
      const response = await makeRequest(
        "post",
        `api/v1/identification/tiger_images`,
        data
      );
      if (response.data.data.length > 0) {
        const namesArray = response.data.data.map((item) => item.name);
        if (namesArray.length > 0) {
          setIsPopupOpen(true);
        }

        setClickedTiger(id);
        setTigerData(response.data.data);
        setActiveButton(response.data.data[0].name);
        setSelectedTigerIndex(0);
        // setIsPopupOpen(false);
        setPopupLoading(false);
      } else {
        setIsPopupOpen(false);
        setPopupLoading(false);
        toast.success("Unable to Identify Tigers", warningToaster);
      }
    } catch (error) {
      setIsPopupOpen(false);
      setPopupLoading(false);
      toast.success("Unable to Identify Tigers", warningToaster);
    }
  };

  const fetchUnidentifiedTigerImages = async (id) => {
    setPopupLoading(true);

    try {
      let token = "";
      if (localStorage.token) {
        token = localStorage.token;
      }

      // Define the data to send in the request body
      const data = { id: id };

      // Make the API call using your existing makeRequest function
      const response = await makeRequest(
        "post",
        `api/v1/identification/tiger_images_unidentified/`,
        data
      );

      // Handle the response
      if (response.data && response.data.data.length > 0) {
        const tigerData = response.data.data;
        setUnableToIdentifyTigerData(tigerData);
        setUnableToIdentifyModalOpen(true);
      } else {
        toast.success("No unidentified tigers found", warningToaster);
        setUnableToIdentifyModalOpen(false);
      }
    } catch (error) {
      toast.success(
        "Failed to fetch unidentified tiger images",
        warningToaster
      );
      setUnableToIdentifyModalOpen(false);
    } finally {
      setPopupLoading(false);
    }
  };

  useEffect(() => {
    if (selectedIndex && selectedIndex !== null) {
      fetchAdditionalImages("identified", selectedIndex);
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (selectedUnidIndex && selectedUnidIndex !== null) {
      fetchAdditionalImages("unidentified", selectedUnidIndex);
    }
  }, [selectedUnidIndex]);

  useEffect(() => {
    if (tigerData.length > 0) {
      setSelectedTiger(
        tigerData[selectedTigerIndex]?.images[selectedImageIndex]?.image_key ||
          ""
      );
    }
  }, [tigerData, selectedImageIndex, selectedTigerIndex]);

  const handleLeftArrowClick = () => {
    const imagesCount = tigerData[selectedTigerIndex]?.images?.length || 0;
    if (imagesCount > 0) {
      setSelectedImageIndex((prevIndex) => {
        if (prevIndex > 0) {
          return prevIndex - 1;
        } else {
          return imagesCount - 1;
        }
      });
    }
  };

  const handleRightArrowClick = () => {
    const imagesCount = tigerData[selectedTigerIndex]?.images?.length || 0;
    if (imagesCount > 0) {
      setSelectedImageIndex((prevIndex) => {
        if (prevIndex < imagesCount - 1) {
          return prevIndex + 1;
        } else {
          return 0;
        }
      });
    }
  };

  const handleNameClick = (selectedOption) => {
    const flag = selectedOption === activeButton ? null : selectedOption;
    setActiveButton(flag);
    const selectedTigerIndex = tigerData.findIndex(
      (tiger) => tiger.name === selectedOption
    );
    if (selectedTigerIndex !== -1) {
      setSelectedTigerIndex(selectedTigerIndex);
      setSelectedImageIndex(0);
    }
  };

  const handleTabChange = (tabName) => {
    setIsPopupOpen(false);
    setActiveTab(tabName);
  };

  const handlePrev = (index, setter, ids) => {
    const currentIndex = ids.indexOf(index);
    if (currentIndex > 0) {
      setter(ids[currentIndex - 1]);
    }
  };

  const handleNext = (index, setter, ids) => {
    const currentIndex = ids.indexOf(index);
    if (currentIndex < ids.length - 1) {
      setter(ids[currentIndex + 1]);
    } else {
      setIsPopupOpen(false);
    }
  };

  const revertTigerIdentification = async () => {
    const selectedTiger = identifiedTigers.find(
      (item) => item.id === selectedIndex
    );

    try {
      const result = await makeRequest(
        "put",
        "api/v1/identification/revert_tiger_identification/",
        { id: selectedTiger.id },
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`
          },
        }
      );

      if (selectedTiger) {
        const unIdentifiedTiger = {
          ...selectedTiger,
          fileName: selectedTiger.image, // Rename `image` to `fileName`
          name: "Unidentified", // Add new field `name`
          species: "Tiger", // Add new field `species`
        };

        delete unIdentifiedTiger.image; // Remove `image`
        delete unIdentifiedTiger.species_data_id; // Remove `species_data_id`
        delete unIdentifiedTiger.species_name; // Remove `species_name`

        const filteredItems = identifiedTigers.filter(
          (item) => item.id !== selectedIndex
        );
        setIdentifiedTigers(filteredItems);

        setUnIdentifiedTigers((prev) => [...prev, unIdentifiedTiger]);

        // Show success message and reset button state
        toast.success(`Successfully Unidentified Image`, {
          ...warningToaster,
          autoClose: 2000,
        });
        // setActiveButton(false);
      }
    } catch (error) {
      toast.success(`Unidentification Unsuccessful`, {
        ...warningToaster,
        autoClose: 2000,
      });
      console.error("Error reverting tiger identification:", error);
      props.closeEditImgPopup();
    }
  };

  return (
    <>
      {popupLoading ? (
        <div className="loading-mask">
          <div style={{ textAlign: "center" }}>
            <ClipLoader
              color={"green"}
              loading={popupLoading}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            <p style={{ marginTop: "10px", color: "green" }}>
              Loading Matching Tigers...
            </p>
          </div>
        </div>
      ) : (
        <div>
          <div className="ClassificationContainer" style={{ height: "100%" }}>
            <div className="ClassificationContainerHeader">
              <div
                className={
                  activeTab === "identified"
                    ? "classification_type classification_type_active"
                    : "classification_type"
                }
                onClick={() => handleTabChange("identified")}
              >
                <img
                  src={require("../../Assets/Icons/ImagesGroup.png")}
                  alt=""
                />
                <span style={{ fontSize: "1rem", marginRight: "1vw" }}>Identified Tigers</span>
                <span>({Object.keys(identifiedTigers).length})</span>
              </div>
              <div
                className={
                  activeTab === "unidentified"
                    ? "classification_type classification_type_active"
                    : "classification_type"
                }
                onClick={() => handleTabChange("unidentified")}
              >
                <img
                  src={require("../../Assets/Icons/ImageAlert.png")}
                  alt=""
                />
                <span style={{ fontSize: "12px" }}>Unidentified Tigers</span>
                <span>({unIdentifiedTigers.length})</span>
              </div>
              <div
                className={
                  activeTab === "unableToIdentify"
                    ? "classification_type classification_type_active"
                    : "classification_type"
                }
                onClick={() => handleTabChange("unableToIdentify")}
              >
                <img
                  src={require("../../Assets/Icons/ImageAlert.png")}
                  alt=""
                />
                <span style={{ fontSize: "12px" }}>Unable To Identify</span>
                <span>({unableToIdentifyTigers.length})</span>
              </div>
              <div>
                {activeTab === "identified" && (
                  <span style={{ fontSize: "9px" }}>
                    {
                      "* These are the matched tigers where score is > 50% you can manually verify the tiger by clicking on identify tiger."
                    }
                  </span>
                )}
                {activeTab === "unidentified" && (
                  <span style={{ fontSize: "9px" }}>
                    * Please click on Identify Tiger button to manually identify
                    as the matching score for the identification is below 50%.
                  </span>
                )}
                {activeTab === "unableToIdentify" && (
                  <span style={{ fontSize: "9px" }}>
                    * Unable to identify the below images. You can find these
                    images in 'Unidentified' folder in the tiger images and edit
                    them.
                  </span>
                )}
              </div>
            </div>
          </div>
          {uploadView && (
            <>
              {activeTab === "identified" && (
                <div className="Images_View" style={{ marginLeft: "25px" }}>
                  <div className="Images_view">
                    <div
                      className="ImageBox"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                      }}
                    >
                      {identifiedTigers.map((tiger, index) => (
                        <TigerCard
                          key={index}
                          tiger={tiger}
                          index={index}
                          isPopupOpen={isPopupOpen}
                          clickedTiger={clickedTiger}
                          setIsPopupOpen={setIsPopupOpen}
                          fetchAdditionalImages={fetchAdditionalImages}
                          tigerData={tigerData}
                          selectedTigerIndex={selectedTigerIndex}
                          selectedTiger={selectedTiger}
                          handleLeftArrowClick={handleLeftArrowClick}
                          handleRightArrowClick={handleRightArrowClick}
                          activeButton={activeButton}
                          handleNameClick={handleNameClick}
                          identifyHandler={identifyHandler}
                          tigerIds={tigerIds}
                          selectedIndex={selectedIndex}
                          setSelectedIndex={setSelectedIndex}
                          handlePrev={handlePrev}
                          handleNext={handleNext}
                          revertTigerIdentification={revertTigerIdentification}
                          isIdentified={true}
                          tigerslist={tigerslist}
                          loading={loading}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {activeTab === "unidentified" && (
                <div className="Images_View" style={{ marginLeft: "25px" }}>
                  <div className="Images_view">
                    <div
                      className="ImageBox"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                      }}
                    >
                      {unIdentifiedTigers.map((tiger, index) => (
                        <TigerCard
                          key={index}
                          tiger={tiger}
                          index={index}
                          isPopupOpen={isPopupOpen}
                          clickedTiger={clickedTiger}
                          setIsPopupOpen={setIsPopupOpen}
                          fetchAdditionalImages={fetchAdditionalImages}
                          tigerData={tigerData}
                          selectedTigerIndex={selectedTigerIndex}
                          selectedTiger={selectedTiger}
                          handleLeftArrowClick={handleLeftArrowClick}
                          handleRightArrowClick={handleRightArrowClick}
                          activeButton={activeButton}
                          handleNameClick={handleNameClick}
                          identifyHandler={identifyHandler}
                          tigerIds={unIdTigerIds}
                          selectedIndex={selectedUnidIndex}
                          setSelectedIndex={setSelectedUnidIndex}
                          handlePrev={handlePrev}
                          handleNext={handleNext}
                          isIdentified={false}
                          unIdentifiedTigers={unIdentifiedTigers}
                          setUnIdentifiedTigers={setUnIdentifiedTigers}
                          tigerslist={tigerslist}
                          loading={loading}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {activeTab === "unableToIdentify" && (
                <div className="Images_View" style={{ marginLeft: "25px" }}>
                  <div className="Images_view">
                    <div
                      className="ImageBox"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                      }}
                    >
                      {unableToIdentifyTigers.map((tiger, index) => (
                        <div
                          key={index}
                          className="Individual_Image"
                          style={{
                            width: "20%",
                            height: "20%",
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <LazyImage src={tiger.fileName} alt={tiger.id} />
                          <div style={{ display: "flex", gap: "1vw", alignItems: "center" }}>
                            {tiger.species_name && (
                              <span style={{
                                marginTop: "10px",
                                fontSize: "0.9rem"
                              }}>{tiger.species_name} *</span>
                            )}
                            <div
                              className="Classify_Section Classify_Header Classify_Upload"
                              onClick={() => {
                                setSelectedTiger(tiger);
                                fetchUnidentifiedTigerImages(tiger.id);
                              }}
                            >
                              <span style={{ cursor: "pointer" }}>
                                {tiger.checked
                                  ? "Identified"
                                  : "Identify Tiger"}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <Popup
                    open={unableToIdentifyModalOpen}
                    onClose={() => setUnableToIdentifyModalOpen(false)}
                    modal
                    nested
                  >
                    {selectedTiger && (
                      <UnableToIdentifyModal
                        unableToIdentifyTigers={unableToIdentifyTigers}
                        setUnableToIdentifyTigers={setUnableToIdentifyTigers}
                        unableToIdentifyTigerData={unableToIdentifyTigerData}
                        selectedTiger={selectedTiger}
                        setSelectedTiger={setSelectedTiger}
                        fetchUnidentifiedTigerImages={
                          fetchUnidentifiedTigerImages
                        }
                        tigerslist={tigerslist}
                        loading={loading}
                        setUnableToIdentifyModalOpen={
                          setUnableToIdentifyModalOpen
                        }
                      />
                    )}
                  </Popup>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default IdentifiedContainer;
